<template>
    <div class="legal-person-step1" v-loading="pageLoading">
        <el-form ref="formData" class="sr-from-single" label-width="150px" :model="formData">
            <el-form-item style="margin-bottom: 0px" label="对公账户名">
                <p>{{ certifyInfo.entAccountName }}</p>
            </el-form-item>
            <el-form-item style="margin-bottom: 40px" label="对公银行卡号">
                <p>{{ certifyInfo.entBankCard }}</p>
            </el-form-item>
            <el-form-item prop="payNumber" label="收到的金额" :rules="[{ required: true, message: '请输入收到的打款金额' }]">
                <p class="important-tips">因银行打款、核验金额有延迟，建议在收到打款后5分钟再进行验证</p>
                <el-input v-model="formData.payNumber" placeholder="请输入收到的打款金额"></el-input>
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary" :loading="loading" @click="onSubmit">立即校验</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { enterpriseBankAmountConfirm } from '@/api/user';
export default {
    components: {},
    data() {
        return {
            pageLoading: false,
            loading: false,
            formData: {
                payNumber: '', // 打款金额
            },
            certifyInfo: {},
        };
    },
    mounted() {
        this.initFrom();
    },
    methods: {
        async initFrom() {
            const { certifyInfo } = this.$store.getters;
            this.certifyInfo = certifyInfo;
        },
        async onSubmit() {
            const valid = await this.$refs['formData'].validate();
            if (!valid) return;
            this.loading = true;
            const respnose = await enterpriseBankAmountConfirm(parseFloat(this.formData.payNumber));
            const { state, msg } = respnose.data;
            this.loading = false;
            this.$emit('updateStep');
            if (!state) return this.$message.error(msg || '打款金额验证失败，请稍后尝试');
        },
    },
};
</script>
<style lang="scss" scoped></style>
